import { render, staticRenderFns } from "./DCAddNotesAndPhotos.vue?vue&type=template&id=57a434af&scoped=true&"
import script from "./DCAddNotesAndPhotos.vue?vue&type=script&lang=js&"
export * from "./DCAddNotesAndPhotos.vue?vue&type=script&lang=js&"
import style0 from "./DCAddNotesAndPhotos.vue?vue&type=style&index=0&id=57a434af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a434af",
  null
  
)

export default component.exports